@if (!advancedMenuEnabled) {
  <div class="category-header">
    <h4>Products</h4>
  </div>
}

<p-panelMenu [model]="items" [transitionOptions]="'0.2s ease-in'"></p-panelMenu>
